import React, { Component } from 'react';

import AsyncSelect from 'react-select/async';
import { mostrarMensajeDeErrorConToast, responseCode200 } from '../../consumers/httpRequiestsUtils';
import { mapDropDownOptionsFromBackendToSelectOptionsNeededForLibrary } from '../../helper/utils';
import { usePostRequest } from '../../hooks/usePostRequest/usePostRequest';

 const AsyncSelectInputCustomPost = ({api, placeholder, handleSelectInputChange, isDisabled, value, isMulti, buildPayload }) => {
    const [executePostRequest] = usePostRequest();
    const defaultEmptyValue = { value: "", label: "" };
    const loadOptions = (inputValue, callback) => {
        if(!inputValue) {
            return callback([]);
        }
        setTimeout(async () => {
            const payload = buildPayload
                ? buildPayload(inputValue)
                : { Criteria: inputValue };
            let response = await executePostRequest(api(), payload);
            if (responseCode200(response)) {
                const options = response.data.map(item => ({
                    label: item.label,
                    value: item.value,
                    data: item
                }));
                callback(options);
            } else {
                mostrarMensajeDeErrorConToast(response);
            }
        }, 1000);
    };

    const handleInputChange = (newValue) => {
        return newValue;
    };

    return (
        <>
            <AsyncSelect
                cacheOptions
                loadOptions={loadOptions}
                defaultOptions
                onInputChange={handleInputChange}
                placeholder={placeholder}
                onChange={handleSelectInputChange}
                isDisabled={isDisabled}
                value={value}
                menuPosition='fixed' // check
                isMulti = {isMulti}
            />
        </>
    );
}

export default AsyncSelectInputCustomPost;